import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { CVDriveComponent } from './components/CV-drive/CV-drive.component';
import { JobOfferLibraryComponent } from './components/job-offer-library/job-offer-library.component';
import { AnalyzerComponent } from './components/analyzer/analyzer.component';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { getCookie } from '../../../utils/getCookies';
import { TranslateModule } from '@ngx-translate/core';
import { ModalGeneralComponent } from '../../user/modals/modal-general/modal-general.component';
import { MatDialog } from '@angular/material/dialog';
import { ModalWithResponseComponent } from '../../user/modals/modal-with-response/modal-with-response.component';
import { filter, Subscription } from 'rxjs';

@Component({
  selector: 'app-cv-deep-analyzer',
  standalone: true,
  imports: [CommonModule, FormsModule, MatButtonModule, MatFormFieldModule, MatSelectModule, RouterModule, JobOfferLibraryComponent, CVDriveComponent, AnalyzerComponent, TranslateModule  ],
  templateUrl: './cv-deep-analyzer.component.html',
  styleUrl: './cv-deep-analyzer.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class CVDeepAnalyzerComponent implements OnInit, OnDestroy {

  is_demo_deep_cv: boolean = false;
  
  private navigationSub?: Subscription;

  constructor(private router: Router, private http: HttpClient, private dialog: MatDialog) {
    this.getanalysisData();
    this.id_analysis = localStorage.getItem('conectio_client_id_analysis') || '';
    this.list_active_analysis = JSON.parse(localStorage.getItem('conectio_client_list_active_analysis') || '[]');

    if (getCookie('is_demo_deep_cv') === 'true') {
      this.is_demo_deep_cv = true;
    }
    
   }

   getanalysisData() {
    this.analysis_loading = true;
    this.http.get(`${environment.url}/api/v1/CVDeepAnalyzer/analyzer/get_all_analysis`, { headers: this.buildAuthHeaders() }).subscribe((res: any) => {
      this.analysis_loading = false;
      this.analysis_data = res.analysis;

      for (const analysis of this.analysis_data) {
        if (this.list_active_analysis.find((analysis_item: any) => analysis_item.id === analysis.id)) {
          // if it is in the list of active analysis, we update the name and the selected_json
          const index = this.list_active_analysis.findIndex((analysis_item: any) => analysis_item.id === analysis.id);
          if (index !== -1) {
            this.list_active_analysis[index] = {
              id: analysis.id,
              name: analysis.name || 'Analysis #' + analysis.id,
              selected_json: analysis.selected_json || {},
            };
          }
        }
      }


      // we can be in the case that other people deleted an analysis and the id is still in the list of active analysis, so for that we need to delete the id from the list of active analysis
      const all_ids_analysis = this.analysis_data.map((analysis: any) => analysis.id);
      this.list_active_analysis = this.list_active_analysis.filter((analysis_item: any) => all_ids_analysis.includes(analysis_item.id));
      localStorage.setItem('conectio_client_list_active_analysis', JSON.stringify(this.list_active_analysis));

    });
   }

  ngOnInit(): void {
    this.loadJobOfferNameMap();
    this.id_analysis = localStorage.getItem('conectio_client_id_analysis') || '';
    // reload analysis when navigating back to the home route
    this.navigationSub = this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (event.urlAfterRedirects.endsWith('/dashboard/company/cv-deep-analyzer')) {
          this.getanalysisData();
        }
      });
  }

  ngOnDestroy(): void {
    this.navigationSub?.unsubscribe();
  }

  isIntheDistributor(): boolean {
    return this.router.url.endsWith('/dashboard/company/cv-deep-analyzer');
  }
  
  listJobOffers: any[] = [];
  listCVs: any[] = [];
  selectedLanguage: string = 'es'; // Default language

  iscvActivated() {
    return this.router.url.includes('/dashboard/company/cv-deep-analyzer/CV-drive');
  }

  isjobOfferLibraryActivated : boolean = false;

  iscompareCVJobOfferActivated() {
    return this.router.url.includes('/dashboard/company/cv-deep-analyzer/analyzer');
  }

  // function and variables for the setting analysis
  loading_seting_analysis : boolean = false;
  id_analysis: any = '';

  SetAnalysis() {
    // avoid triggering backend calls in demo mode
    if (this.is_demo_deep_cv) {
      return;
    }
    this.loading_seting_analysis = true;
    const headers = this.buildAuthHeaders();
    this.http.post(`${environment.url}/api/v1/CVDeepAnalyzer/analyzer/set_analysis_cv`, {
      language: this.selectedLanguage
      }, { headers }).subscribe((res: any) => {
        this.loading_seting_analysis = false;
        this.id_analysis = res.id_analysis;
        localStorage.setItem('conectio_client_id_analysis', res.id_analysis);
        
        if (this.list_active_analysis.length >= 4) {
          this.list_active_analysis.shift();
        }
        this.list_active_analysis.push({
          id: res.id_analysis,
          name: 'Analysis #' + res.id_analysis,
          selected_json: {},
        });
        localStorage.setItem('conectio_client_list_active_analysis', JSON.stringify(this.list_active_analysis));

        // if is successfully set the analysis, we navigate to the analyzer page
        this.router.navigate(['/dashboard/company/cv-deep-analyzer/CV-drive'], { queryParams: { id_analysis: res.id_analysis } });

      }, (error: any) => {
        this.loading_seting_analysis = false;
        console.error('Error setting analysis', error);
      });
  }

  // function to check if the user is in the home page and get the analysis done
  analysis_loading: boolean = false;
  analysis_data: any[] = [];
  jobOfferNameMap: Record<string, string> = {};
  jobOfferNameLoading = false;
  editingAnalysisId: number | null = null;
  editingAnalysisName = '';
  editingAnalysisSaving = false;

  isInHome() {
    return this.router.url.endsWith('/dashboard/company/cv-deep-analyzer');
  }

  getCVCount(analysis: any): number {
    return this.normalizeSelectedJson(analysis?.selected_json).CV.length;
  }

  getJobOfferNames(analysis: any): string[] {
    const selected = this.normalizeSelectedJson(analysis?.selected_json).job_offers;
    const uniqueIds = Array.from(new Set(selected));
    return uniqueIds.map((id: any) => this.jobOfferNameMap[id] || `Job offer ${id}`);
  }

  getJobOfferCount(analysis: any): number {
    return this.normalizeSelectedJson(analysis?.selected_json).job_offers.length;
  }

  startEditingAnalysis(analysis: any) {
    this.editingAnalysisId = analysis?.id || null;
    this.editingAnalysisName = analysis?.name || '';
  }

  cancelEditingAnalysis() {
    this.editingAnalysisId = null;
    this.editingAnalysisName = '';
  }

  saveAnalysisName(analysis: any) {
    if (!this.editingAnalysisId) {
      return;
    }

    const trimmedName = this.editingAnalysisName.trim();
    if (!trimmedName) {
      return;
    }

    this.editingAnalysisSaving = true;
    const payload = {
      id_analysis: this.editingAnalysisId,
      name: trimmedName
    };

    this.http.post(`${environment.url}/api/v1/CVDeepAnalyzer/analyzer/change_name_analysis`, payload, { headers: this.buildAuthHeaders() })
      .subscribe({
        next: () => {
          analysis.name = trimmedName;
          this.cancelEditingAnalysis();
          this.editingAnalysisSaving = false;

          // we update the name of the analysis in the list of new analysis
          const index = this.list_active_analysis.findIndex((analysis_item: any) => analysis_item.id === payload.id_analysis);
          if (index !== -1) {
            this.list_active_analysis[index] = {
              id: payload.id_analysis,
              name: payload.name,
            }
          }
          localStorage.setItem('conectio_client_list_active_analysis', JSON.stringify(this.list_active_analysis));

        },
        error: (error) => {
          console.error('Error updating analysis name', error);
          this.editingAnalysisSaving = false;
        }
      });
  }

  private normalizeSelectedJson(selected: any): { CV: any[]; job_offers: any[] } {
    if (!selected) {
      return { CV: [], job_offers: [] };
    }

    let parsed = selected;
    if (typeof selected === 'string') {
      try {
        parsed = JSON.parse(selected);
      } catch (error) {
        parsed = {};
      }
    }

    return {
      CV: Array.isArray(parsed?.CV) ? parsed.CV : [],
      job_offers: Array.isArray(parsed?.job_offers) ? parsed.job_offers : []
    };
  }

  private loadJobOfferNameMap() {
    this.jobOfferNameLoading = true;
    this.http.get(`${environment.url}/api/v1/JobOfferAnalyzer/JobOffer/get_files`, { headers: this.buildAuthHeaders() }).subscribe((res: any) => {
      const map: Record<string, string> = {};
      const groupedFiles = res?.files ?? {};

      Object.values(groupedFiles).forEach((group: any) => {
        (group as any[]).forEach((jobOffer: any) => {
          if (jobOffer?.id) {
            map[jobOffer.id] = jobOffer?.preprocessed_json?.title || jobOffer?.file_name || `Job offer ${jobOffer.id}`;
          }
        });
      });

      this.jobOfferNameMap = map;
      this.jobOfferNameLoading = false;
    }, () => {
      this.jobOfferNameLoading = false;
    });
  }

  private buildAuthHeaders(): HttpHeaders {
    const accessToken = getCookie('access_token');
    return new HttpHeaders({
      'Authorization': `Bearer ${accessToken}`
    });
  }


  // delete analysis
  deleteAnalysis(analysis: any) {

    // we open the confirm modal
    ModalWithResponseComponent.open(this.dialog, {
      title: 'CVDeepAnalyzer.history.deleteAnalysisTitle',
      message: 'CVDeepAnalyzer.history.deleteAnalysisMessage',
      buttonText: 'CVDeepAnalyzer.history.deleteAnalysisButton',
      buttonTextCancel: 'CVDeepAnalyzer.history.deleteAnalysisButtonCancel',
    }).afterClosed().subscribe((result: any) => {
      if (result) {
        this.http.post(`${environment.url}/api/v1/CVDeepAnalyzer/analyzer/delete_analysis`, { id_analysis: analysis.id }, { headers: this.buildAuthHeaders() }).subscribe((res: any) => {
          this.getanalysisData();

          // we remove the analysis from the list of active analysis
          const index = this.list_active_analysis.findIndex((analysis_item: any) => analysis_item.id === analysis.id);
          if (index !== -1) {
            this.list_active_analysis.splice(index, 1);
          }
          localStorage.setItem('conectio_client_list_active_analysis', JSON.stringify(this.list_active_analysis));
        }, (error: any) => {
          console.error('Error deleting analysis', error);
        });
      }
    });
  }

  startNewAnalysis() {
    this.router.navigate(['/dashboard/company/cv-deep-analyzer/CV-drive']);
  }

  // list of new analysis
  list_active_analysis: any[] = [];

  viewAnalysis(analysis: any) {
    localStorage.setItem('conectio_client_id_analysis', analysis.id);
    
    if (this.list_active_analysis.filter((analysis_item: any) => analysis_item.id === analysis.id).length == 0) {

      // if the list of new analysis is greater than 4, we remove the first item
      if (this.list_active_analysis.length >= 4) {
        this.list_active_analysis.shift();
      }
      // we add the new analysis to the list
      this.list_active_analysis.push({
        id: analysis.id,
        name: analysis.name || 'Analysis #' + analysis.id,
        selected_json: analysis.selected_json || {},
      });
    }

    localStorage.setItem('conectio_client_list_active_analysis', JSON.stringify(this.list_active_analysis));

    this.id_analysis = analysis.id;
    if (analysis.selected_json?.job_offers?.length > 0) {
      this.router.navigate(['/dashboard/company/cv-deep-analyzer/analyzer'], { queryParams: { id_analysis: analysis.id } });
    } else {
      this.router.navigate(['/dashboard/company/cv-deep-analyzer/CV-drive'], { queryParams: { id_analysis: analysis.id } });
    }
  }

  removeAnalysisfromActive(analysis: any, event: any) {
    event.stopPropagation();
    // we remove the analysis from the list of active analysis
    const index = this.list_active_analysis.findIndex((analysis_item: any) => analysis_item.id === analysis.id);
    if (index !== -1) {
      this.list_active_analysis.splice(index, 1);
    }
    localStorage.setItem('conectio_client_list_active_analysis', JSON.stringify(this.list_active_analysis));

    if (this.id_analysis == analysis.id && !this.isInHome()) {
      this.id_analysis = "";
      localStorage.removeItem('conectio_client_id_analysis');
      this.router.navigate(['/dashboard/company/cv-deep-analyzer']);
      this.getanalysisData();
    }
  }

  getselectedAnalysis() {
    return this.list_active_analysis.find((analysis: any) => analysis.id == this.id_analysis);
  }

  setjobOffersfromcomponent(jobOffers: any[]) {
    if (jobOffers.length > 0) {
      const index = this.list_active_analysis.findIndex((analysis: any) => analysis.id == this.id_analysis);
      if (index !== -1) {
        this.list_active_analysis[index].selected_json.job_offers = jobOffers;
      }
      localStorage.setItem('conectio_client_list_active_analysis', JSON.stringify(this.list_active_analysis));
    }
  }

}
